/**
 * Checks if a string contains only numeric characters
 */
export const hasOnlyNumbers = (str: string): boolean => {
  return /^\d+$/.test(str);
};


